// feeds RESOURCES - list page
import { Link } from "react-router-dom";
import React from "react";
import Seo from "./Seo";
// import React from "react";
//import ResourcesList from "./assets/resources/ResourcesList";


function MainContent4({resource}) {
  // const article = ResourcesList.find(article => article.objectName === articleId);
  // console.log('MC4', ResourcesList);
  //console.log('mc4', resource)
  // CHANGE Resources List to {resource.heading}
    return (
      <>
      <Seo title={resource.tabHeading} description={resource.metaDescription} keywords={resource.keywords} />
      <h2 className="sectionHeader">{resource.heading}</h2>
      <p className="main marginClear paddingClear"><b>NOTE: </b>{resource.refresh}</p>
      <p className="main marginClear">{resource.description}</p>
      <div className="main">
        <div className="rListCont"><ul className="ulNone">
        {resource.list.map((listItem, li) => {
            return (
                <li key={li} className="rList">
                <div>
                <p className="citeTitle hasImgTag resources"><img className="imgTag" src={listItem.thumbImg} alt="" /> {listItem.firstName} {listItem.lastName}</p>
                <ul className="ulNone">
                {listItem.quotes.map((quoteList, i) => {
                  return (
                      <React.Fragment key={i}>
                      <li>
                      <Link to={`/${listItem.objectName}/${quoteList.id}`} 
                      title={quoteList.title} 
                      className="rLinks"><div className="rLinksDiv">                     
                      <p className="rTitle"><b><span className="rListFrom">{quoteList.from}</span>{quoteList.title}</b> <i className="rListFrom">{quoteList.date}</i></p>
                      <p className="short">{quoteList.short}</p>
                      </div></Link>
                      </li>
                      <hr aria-hidden />
                      </React.Fragment>
                    )
                })}
                
                </ul></div></li>
                        
            )
        })}
        </ul></div>
        
        
      </div>
      </>
    );
  };
  export default MainContent4;

